<template>
  <div class="Home">
    <div class="pcblock">
      <div class="banner" @click="openSignDialog" v-if="!isMobile">
        <img src="../../assets/image/banner.jpg" alt="" />
      </div>
      <div class="homebox1">
        <div class="home-title padb10">
          <img src="../../assets/image/Property-left.svg" alt="" />
          培训信息
          <img src="../../assets/image/Property-right.svg" alt="" />
        </div>
        <div class="home-content home-text text-center">
          为贯彻落实国家卫生健康委关于2025年卫生健康系统为民服务实事项目和《医疗卫生强基工程实施方案》的有关要求，加强基层透析服务供给和综合能力提升，为人民群众提供规范的透析服务，进一步完善透析中心建设，提高人才队伍岗位胜任力与服务水平，切实提升透析服务质量和可及性，国家卫生健康委人口文化与基层健康中心（以下简称“基层健康中心”）发起主办“基层透析服务能力提升项目”。培训采用线上+线下，理论+实操的方式进行。基础理论制作成视频课件，放至此平台供学员日常学习。线下培训以模拟实操和病例讲解为主。
        </div>
      </div>
      <div class="homebox1">
        <div class="boxitem">
          <h3>一、培训对象</h3>
          <div class="home-text">
            以该地级市周边区县的透析从业人员为主，每期培训150人（覆盖10个区县，平均每个区县三家医院，每家医院两名医生、两名护士、一名技师）。
          </div>
        </div>
        <div class="boxitem padb10">
          <h3>二、培训时间</h3>
          <div class="home-text">
            2026年5月11日-12月30日，线上线下同步，2026年计划培训30期，每期3天。
          </div>
        </div>
        <div class="boxitem padb10">
          <h3>三、培训内容</h3>
          <div class="imginfo">
            <img src="../../assets//image/tableview.png" alt="" />
          </div>
        </div>
      </div>
      <!-- 报名按钮 -->
      <div class="btnbox">
        <div class="signbtn text-center" @click="openSignDialog">立即报名</div>
      </div>
      <!-- 对话框 -->
      <el-dialog
        title="报名"
        :visible.sync="SignDialog"
        :width="isMobile ? '100%' : '40%'"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <div class="mobileblock">
          <signModule :hasRegistered="hasRegistered"></signModule>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import signModule from "../../components/signModule.vue";
import { hasToken } from "../../assets/js/storage";
import { getRegistrationInfo } from "../API/user";
import { loginTicket } from "../API/login";
import { setToken } from "../../assets/js/storage";
export default {
  props: ["isWeChat"],
  data() {
    return {
      hasRegistered: false,
      SignDialog: false,
      isMobile: document.body.clientWidth < 540 ? true : false,
      needBindMobile: false,
    };
  },
  components: { signModule },
  created() {
    console.log("isWeChat",this.isWeChat);
    this.wechatloginHandle();
  },
  mounted() {},
  methods: {
    async wechatloginHandle() {
      const ticket = this.getQueryParam("ticket")
        ? this.getQueryParam("ticket")
        : "";
      console.log("ticket:" + ticket);
      if (ticket && !hasToken()) {
        const res = await loginTicket({ ticket });
        if (res.data.code === 1) {
          this.needBindMobile = res.data.data.needBindMobile;
          setToken(res.data.data.accessToken);
          if (this.needBindMobile) {
            this.$emit("openbindDialog");
          } else {
            // 登录成功
            this.$message({
              message: "登录成功",
              type: "success",
            });
            localStorage.setItem(
              "UserInfo",
              JSON.stringify(res.data.data.userInfo),
            );
            return this.$router.push({ name: "User" });
          }
        } else {
          localStorage.clear();
          this.$router.push({ name: "Home" });
        }
      }
    },
    getQueryParam(name) {
      const regex = new RegExp("[?&]" + name + "=([^&]*)");
      const results = regex.exec(window.location.search);
      return results ? decodeURIComponent(results[1]) : null;
    },
    // 检测报名状态
    async getReInfo() {
      if (hasToken()) {
        const { data: res } = await getRegistrationInfo();
        this.hasRegistered = res.data.hasRegistered;
        if (!this.hasRegistered) {
          if (this.needBindMobile) {
            this.$message.warning("您还未绑定手机号");
            return this.$emit("openbindDialog");
          } else {
            this.SignDialog = true;
          }
        } else {
          return this.$message.warning("您已经报名过了");
        }
      }
    },
    handleClose() {
      this.SignDialog = false;
    },
    openSignDialog() {
      if (hasToken()) {
        // 检测报名状态
        this.getReInfo();
      } else {
        this.$emit("openLoginDialog");
        this.$message.warning("请您先登录");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.Home {
  width: 100%;
  overflow: hidden;
  background: #f9faff;
  .footer {
    background: #f7faff;
  }
  .mobileblock {
    @media screen and (max-width: 540px) {
      padding: 20px;
    }
  }
  .flex-layout {
    display: flex;
    align-items: center;
    @media screen and (max-width: 540px) {
      display: block;
    }
  }
  .pcblock {
    width: 62%;
    margin: 20px auto;
    padding-bottom: 30px;
    background: #ffffff;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    @media screen and (max-width: 540px) {
      margin: 0 auto;
    }
    .banner {
      height: 375px;
      background: #eee;
      cursor: pointer;
      width: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    @media screen and (max-width: 540px) {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .text-center {
      text-align: center;
    }
    .btnbox {
      padding: 50px 0;
    }
    .signbtn {
      margin: auto;
      width: 248px;
      height: 60px;
      line-height: 60px;
      background: linear-gradient(86deg, #6f44a1 0%, #05258e 100%);
      box-shadow: 0px 8px 17px 0px #c3cbe5;
      border-radius: 6px 6px 6px 6px;
      border: 1px solid;
      font-weight: bold;
      font-size: 18px;
      cursor: pointer;
      color: #ffffff;
      border-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.5),
          rgba(255, 255, 255, 1)
        )
        1 1;
    }
    .text-left {
      text-align: left !important;
    }
    .home-title {
      font-weight: bold;
      font-size: 30px;
      color: #05258e;
      text-align: center;
      @media screen and (max-width: 540px) {
        font-size: 24px;
      }
    }
    .home-content {
      padding: 0 100px;
      @media screen and (max-width: 540px) {
        padding: 0;
      }
    }
    .padb10 {
      padding-bottom: 10px;
    }
    .padb20 {
      padding-bottom: 20px;
    }
    .pad20 {
      padding: 20px !important;
    }
    .margr20 {
      margin-right: 20px;
      @media screen and (max-width: 540px) {
        margin-right: 0;
      }
    }
    .padl20 {
      padding-left: 20px;
    }
    .boxitem {
      padding: 0 40px;
      padding-top: 30px;
      h3 {
        padding-bottom: 10px;
        color: #05258e;
      }
      .imginfo {
        padding: 0 200px;
        img {
          width: 100%;
          height: 720px;
          @media screen and (max-width: 540px) {
            height: 350px;
          }
        }
        @media screen and (max-width: 540px) {
          padding: 0 1px;
        }
      }
    }
    .boxitem2 {
      padding: 10px 20px;
      background: #e9ecf9;
      font-size: 18px;
      margin-bottom: 20px;
      flex: 1;
      h4 {
        text-align: center;
        font-weight: normal;
        font-size: 16px;
        padding-bottom: 10px;
      }
      h3 {
        font-size: 20px;
        text-align: center;
        color: #6f44a1;
        @media screen and (max-width: 540px) {
          font-size: 18px;
        }
      }
      span {
        padding-right: 30px;
        color: #05258e;
        font-weight: bold;
        @media screen and (max-width: 540px) {
          display: block;
        }
      }
      h5 {
        font-size: 18px;
        font-weight: normal;
        display: inline-block;
        @media screen and (max-width: 540px) {
          display: block;
          padding-left: 18px;
          padding-top: 10px;
        }
      }
      .itemdate {
        color: #05258e;
      }
      a {
        color: #000;
      }
      p {
        text-align: center;
        font-size: 16px;
      }
      .itemtitle {
        padding: 10px 0;
        font-weight: bold;
        color: #05258e;
        font-size: 20px;
      }
    }
    .home-text {
      font-weight: 400;
      font-size: 18px;
      line-height: 32px;
      color: #232426;
    }
    .homebox1 {
      padding-top: 50px;
      padding-bottom: 20px;
      @media screen and (max-width: 540px) {
        padding-top: 20px;
        padding-bottom: 10px;
      }
    }
    .homebox {
      padding: 30px 40px;
      background-color: #f3f6ff;
      border-radius: 10px;
      margin-bottom: 40px;
      @media screen and (max-width: 540px) {
        padding: 10px;
        margin-bottom: 20px;
      }
    }
    .homeborder {
      border: 2px solid #e9ecf9;
    }
  }
}
</style>
